/*@ngInject*/
module.exports = function() {
    return {
        scope: {
            object: '=',
            description: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function() {
            let vm = this;

            vm.$onInit = function() {
                for(let index in vm.object.version.description) {
                    const description = vm.object.version.description[index];
                    vm.description[description.language] = description;
                }
            };
        },

        template: require('./objects-edit-description.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/edit/directives/objects-edit-description.directive.js
 **/